import $ from 'jquery';

import ClickOutside from './click-outside';

export default class TaxonomyNavigation {
  init () {
    const button = $('.taxonomy-navigation__button');
    const wrapper = $('.taxonomy-navigation__wrapper');

    // Toggle manual navigation based on click
    button.on('click', () => {
      if (wrapper.is(':hidden')) {
        wrapper.removeClass('d-none');
        new ClickOutside().init('.taxonomy-navigation__wrapper');
      } else {
        wrapper.addClass('d-none');
      }
    });

    // Section tab navigation
    $('.taxonomy-navigation__wrapper').on('click', '[data-toggle]', event => {
      const self = $(event.currentTarget);
      const selector = self.data('toggle');

      $(selector)
        .removeClass('d-none')
        .siblings('.taxonomy-navigation__section')
        .addClass('d-none');
    });
  }
}
